import {addItem, changeListItem, removeItem, setItems, setTableParams} from "../actions/generalActions/listActions";
import { contactService } from "../../jwt/_services/hotel/contactService";
import {setLoading} from "./generalActions/mainActions";
import {setForm} from "./generalActions/formActions";
import {showToastCustom} from "../../components/toast/customToast";
import {utilHelper} from "../../jwt/_helpers";
import {deleteErrorMsg, error} from "../../components/i18n/i18n";

export const search = (pageIndex, pageSize, filter) => ( dispatch ) => {
    dispatch(setLoading(true))

    contactService.search(pageIndex, pageSize, filter)
        .then(result => {
            if (!result)
                return
            dispatch(setItems(result.data))
            dispatch(setTableParams(pageSize, pageIndex, result?.total))
        })
        .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            console.log("Error",error)
        })
        .finally(() => dispatch(setLoading(false)))
}

export const save = (data) => ( dispatch ) => {
    dispatch(setLoading(true))

    contactService.saveItem(data)
        .then(result => {
            dispatch( setForm(false, true, true) )
            dispatch( addItem(result) )
        })
        .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            console.log("Error",error)
        })
        .finally(() => dispatch(setLoading(false)))

}

export const update = (id, data) => ( dispatch ) => {
    dispatch(setLoading(true))

    contactService.updateItem(id, data)
        .then(result => {
            dispatch( setForm(false, true, true) )
            dispatch( changeListItem(result) )
        })
        .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            console.log("Error",error)
        })
        .finally(() => dispatch(setLoading(false)))
}

export const remove = (id, fbDb) => (dispatch) => {
    dispatch(setLoading(true))

    contactService.deleteItem(id, fbDb)
        .then(result => {
            if(result?.status)
                dispatch( removeItem(id) )

            if (utilHelper.hasAssociateRecords()) {
                showToastCustom(error, deleteErrorMsg, true);
                utilHelper.restartAssociateRecords();
            }
        })
        .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            console.log("Error",error)
        })
        .finally(() => dispatch(setLoading(false)))
}
